import { ClientError } from 'graphql-request'

enum HttpStatus {
  FORBIDDEN = 403,
}

export const findForbiddenError = (error: ClientError) =>
  error.response?.errors?.find((err) => err.extensions?.statusCode === HttpStatus.FORBIDDEN)

export const retryChecker = (failureCount: number, error: ClientError): boolean => {
  // Do not retry if a 403 error occurs
  if (findForbiddenError(error)) {
    return false
  }
  // Retry for all other errors
  return failureCount < 3 // Retry up to 3 times
}
